import { useRecoilValue } from "recoil";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { PERMISSIONS } from "../../../PermissionsConstants";
import EmailDomainTable from "./view/EmailDomainTable";

interface Props {}

export const EmailDomain: React.FC<Props> = () => {
  const viewPermission =
    PERMISSIONS.permission_utilities_emaildomain_view;
    const userPermissions = useRecoilValue(permissionsSelector);
  return (
    <> {userPermissions.includes(viewPermission) && <EmailDomainTable />} </>
  );
};

export default EmailDomain;
